const childrenLoaded = require('@alexspirgel/children-loaded');

class IssueFooter extends HTMLElement {
    constructor() {
        super();
    }

    async connectedCallback() {
        await childrenLoaded(this);
        this.init();
    }

    init() {
        const expandAuthors = document.querySelectorAll('.issue-footer__related-resource-expand-authors');
        if (!expandAuthors.length) {
            return;
        }

        if (this.initialized) {
            return;
        }

        expandAuthors.forEach((expandButton) => {
            expandButton.addEventListener('click', (e) => {
                e.stopPropagation();
                const expandElement = expandButton.nextElementSibling;
                const expandElementHeight = expandElement.scrollHeight;

                expandButton.setAttribute('aria-expanded', expandButton.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
                expandElement.style.setProperty('--expand-height', `${expandElementHeight}px`);
                if (expandButton.getAttribute('aria-expanded') === 'true') {
                    expandElement.classList.add('expanded');
                } else {
                    expandElement.classList.remove('expanded');
                }
            });
        });

        this.initialized = true;
    }
}

customElements.define('issue-footer', IssueFooter, {extends: 'section'});